import { Courses } from "../courses"

export const WorkForceLearnings = ({pageSwap, courseToUpdate, setCourseToUpdate, AiStarted }) =>  {
    return(
        <Courses 
            titleScreen = "Workforce learnings"
            CustomerStage={5}
            pageSwap={pageSwap}
            courseToUpdate={courseToUpdate}
            setCourseToUpdate={setCourseToUpdate}
            AiStarted={AiStarted}
        />
    )
}